module.exports = __webpack_public_path__ + "media/ApplicantSummaryMWeb.a1f88dc6.png";